<template>
    <div class="import-tjb-container">
        <div class="card-container">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>请上传包含体检表的压缩包（支持.rar、.zip格式）</li>
                        <li>体检表文件名称格式：考生号.扩展名（如：25420101123456.pdf或25420101123456.jpg）</li>
                        <li>体检表可以是PDF文件或图片文件（jpg、png等）</li>
                        <li>系统将自动匹配考生信息，只保存匹配成功的体检表</li>
                        <li>体检表将存储到：Image/Gxzs/Tjb/{院校代码}/{年份}/</li>
                    </ul>
                </div>
            </div>

            <validation-observer v-slot="{ invalid }">
                <el-form :model="form" label-width="120px" class="import-form">
                    <el-form-item label="体检表压缩包">
                        <validation-provider rules="required" tag="div" v-slot="{ errors, validate }" name="体检表压缩包">
                            <el-upload
                                class="upload-demo"
                                action="#"
                                :auto-upload="false"
                                :on-change="(file) => handleFileChange(file, validate)"
                                :on-remove="handleFileRemove"
                                :on-exceed="handleFileExceed"
                                :file-list="fileList"
                                accept=".rar,.zip"
                                :limit="1">
                                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传rar/zip文件，且不超过500MB。再次选择会替换当前文件。</div>
                            </el-upload>
                            <span class="error-text" v-if="errors[0]">{{ errors[0] }}</span>
                        </validation-provider>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" :disabled="invalid || !uploadFile || submitting" :loading="submitting">
                            <span v-if="!submitting">开始导入</span>
                            <span v-else>导入中...</span>
                        </el-button>
                        <el-button @click="handleReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </validation-observer>

            <!-- 结果显示 -->
            <div v-if="result" class="result-container">
                <el-divider>导入结果</el-divider>
                <div v-html="result" class="result-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'ImportTjb',
    inject: ['Loading', 'LoadingCompleted', 'getCurrentYear'],
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form: {},
            fileList: [],
            uploadFile: null,
            submitting: false,
            result: ''
        };
    },
    methods: {
        handleFileChange(file, validate) {
            // 清空旧文件列表，确保只保留新选择的文件
            this.fileList = [];
            this.uploadFile = file.raw;
            this.fileList = [file];
            validate(file);
        },
        handleFileRemove() {
            this.uploadFile = null;
            this.fileList = [];
        },
        handleFileExceed(files) {
            // 当选择新文件超过限制时，替换原有文件
            this.fileList = [];
            this.$nextTick(() => {
                // 使用新文件替换
                this.uploadFile = files[0];
                this.fileList = [{ name: files[0].name, raw: files[0] }];
            });
        },
        handleSubmit() {
            if (!this.uploadFile) {
                this.$message.warning('请选择要上传的文件');
                return;
            }

            this.submitting = true;
            const api_name = '/Data/ImportTjb';
            // 拼接 year 参数以确保后端 Session 更新
            const year = this.$root.currentYear || '';
            const url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');
            
            const data = {
                Model: JSON.stringify(this.form),
                TjbFile: this.uploadFile
            };

            TYBM_Tools.AxiosUploadFile(this, api_name, url, data, { loading_msg: '正在导入体检表', has_progress: true })
                .then(result => {
                    this.$message.success('导入成功');
                    this.result = result.data.Msg || '导入完成';
                })
                .catch(() => {
                    this.$message.error('导入失败');
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleReset() {
            this.fileList = [];
            this.uploadFile = null;
            this.result = '';
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.import-tjb-container {
    max-width: 900px;
}

.import-form {
    margin-top: 24px;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid;
    background-color: #e6f7ff;
    border-color: #1890ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
    padding: 0;
}

.info-box li {
    margin: 4px 0;
}

.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: block;
}

.result-container {
    margin-top: 24px;
}

.result-content {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
    min-height: 100px;
}

/* 隐藏el-upload的原生input */
.import-form >>> .el-upload {
    display: inline-block;
}

.import-form >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>

